import { trackDictateDeviceButtonPressed } from '@/models/analytics/features/dictate-device-setup-analytics';
import { type HardwareMicButtonPressedPayload } from '@/tauri/dictation/api';
import {
  deviceButtonMappingsAtom,
  dictateMapFunctionalityDialogRequestAtom,
} from '@heidi/dictate/data';
import { getDefaultStore } from 'jotai';

import { handleInsertSnippet } from './insert-snippet';

const INSERT_SNIPPET = 'insert_snippet';

const resolvedAction = (
  payload: HardwareMicButtonPressedPayload
): HardwareMicButtonPressedPayload['action'] =>
  getDefaultStore().get(deviceButtonMappingsAtom)[payload.deviceKey]?.[
    payload.buttonId
  ] ?? payload.action;

export const handleInsertSnippetPress = (
  payload: HardwareMicButtonPressedPayload
): void => {
  if (getDefaultStore().get(dictateMapFunctionalityDialogRequestAtom) !== null) {
    return;
  }
  const action = resolvedAction(payload);
  if (action?.type !== INSERT_SNIPPET || !action.snippetId) {
    return;
  }
  // No `snippetId` on the event: which snippet is content, and the mapping it
  // came from is already the user's own. The press is the measured fact.
  trackDictateDeviceButtonPressed(INSERT_SNIPPET, payload.buttonId);
  void handleInsertSnippet(action.snippetId);
};
